<template>
    <div class="user-home">
        <dashboard :class="`${fake_home ? 'fake' : ''}`">
            <template slot="content">
                <div v-if="success_payment" class="success-msg-con">{{ 'Your purchase has been successful' | translate}}</div>
                <quick-search-panel class="page-con-header"></quick-search-panel>
                <profile-list-with-carousel v-if="topProfiles.length" :title="'Popular Members' | translate" :profiles="topProfiles"></profile-list-with-carousel>
                <div class="with-border-top-wrapped">
                    <profile-list-with-carousel v-if="newProfiles.length" :title="'New Members' | translate" :profiles="newProfiles"></profile-list-with-carousel>
                    <div class="btn-con">
                        <button class="btn btn-primary" @click="$router.push({name: 'user-search-profiles'})">
                            <span>{{ 'Find a Match' | translate }}</span>
                        </button>
                    </div>
                </div>
                <div class="with-border-top-wrapped">
                    <div class="recent-activity-con page-con-header">
                        <div class="title-con">
                            <h4 class="title">{{ 'Recent Activity' | translate }}</h4>
                        </div>
                        <div class="activity-list">
                            <div v-if="!recent_activity.length" class="info-msg-con">
                                <i class="icon icon-info"></i> {{ 'No Recent Activity' | translate }}
                            </div>
                            <div v-for="(activity, key) in recent_activity" :key="key" class="activity">
                                <div class="pic-con" v-if="activity.customer_support">
                                    <img class="img-responsive" :src="activity.thumb_picture">
                                </div>
                                <router-link :to="{ name: 'user-other-profile', params: { name: activity.nick_name } }" class="pic-con" v-else>
                                    <img class="img-responsive" :src="activity.thumb_picture">
                                </router-link>
                                <div class="info-con" @click="$router.push({ name: 'user-other-profile', params: { name: activity.nick_name } })">
                                    <h3 v-if="activity.customer_support">{{ activity.nick_name }}</h3>
                                    <h3 v-else>{{ activity.nick_name }}, {{ activity.age }} {{ 'yr from' | translate }} {{ activity.province_name }}</h3>
                                    <p>{{ activity.text }} <span>{{ activity.date }}</span></p>
                                </div>
                                <div class="icon-actions" v-if="!activity.customer_support">
                                    <i class="icon icon-envelope-solid" @click="$router.push({name: 'user-messages-chat', params: { name: activity.nick_name }})"></i>
                                    <i :class="`favorite fa fa-heart${activity.is_favorite ? '' : '-o'}`" @click="toggleFavorite(activity)" v-if="activity.show_favorite_button"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="mobile-content">
                <template v-if="!fake_home">
                    <div v-if="success_payment" class="success-msg-con">{{ 'Your purchase has been successful' | translate}}</div>
                    <div class="profile-con">
                        <div class="avatar-con">
                            <img class="img-responsive" :src="avatarImage"  @click="$router.push({ name: 'user-photos' })">
                        </div>
                        <div class="details-con">
                            <h2 @click="$router.push({ name: 'user-profile' })">
                                <span class="name">{{ profile.name }} <i class="icon icon-pencil"></i></span>
                                <span :class="`subscription credits ${credits < 10 ? 'basic' : ''}`">
                                    {{ `${credits} ${$t('Credits')}` | normalize }}
                                    <i v-if="isPremium && subscriptionAllowed" class="icon icon-ribbon-colored"></i>
                                    <i v-else :class="`fa ${credits < 10 ? 'fa-frown-o' : 'fa-smile-o'}`"></i>
                                </span>
                            </h2>
                            <button @click="$router.push({ name: 'user-credits' })" class="btn">{{ 'Get Credits' | translate }}</button>
                        </div>
                    </div>
                    <div class="profile-stats-con row">
                        <div class="stats col-xs-3" @click="$router.push({ name: 'user-messages' })">
                            <h2>{{ unreadMessages }}</h2>
                            <h5>{{ 'Messages' | translate | normalize }}</h5>
                        </div>
                        <div class="stats favorites col-xs-3" @click="$router.push({ name: 'user-favorites' })">
                            <h2>{{ profile.total_favorites }}</h2>
                            <h5>{{ 'Favorites' | translate | normalize }}</h5>
                        </div>
                        <div class="stats favorites-others col-xs-3" @click="$router.push({ name: 'user-other-favorites' })">
                            <h2>{{ profile.total_favorites_others }}</h2>
                            <h5>{{ 'likes' | translate | normalize }}</h5>
                        </div>
                        <div class="stats visits col-xs-3" @click="$router.push({ name: 'user-visits' })">
                            <h2>{{ profile.total_visits }}</h2>
                            <h5>{{ 'Visits' | translate | normalize }}</h5>
                        </div>
                    </div>
                    <div class="sub-nav-con">
                        <base-menu class="sub-nav" :menu="sub_nav"></base-menu>
                    </div>
                </template>
                <div v-else class="fake-home profiles-con row">
                    <div v-for="profile in topProfiles" class="col-xs-6 col-sm-4">
                        <profile-thumbnail :info="profile"></profile-thumbnail>
                    </div>
                    <div v-for="profile in newProfiles" class="col-xs-6 col-sm-4">
                        <profile-thumbnail :info="profile"></profile-thumbnail>
                    </div>
                </div>
            </template>
        </dashboard>
    </div>
</template>

<script>
    import Dashboard from '@views/user/layouts/Dashboard'
    import BaseMenu from '@views/common/BaseMenu'
    import QuickSearchPanel from '@views/user/partials/QuickSearchPanel'
    import ProfileListWithCarousel from '@views/user/partials/ProfileListWithCarousel'
    import ProfileThumbnail from '@views/user/partials/ProfileThumbnail'
    import Home from '@views/user/pages/Home/home'

    export default {
        mixins: [Home],
        components: {
            Dashboard,
            BaseMenu,
            QuickSearchPanel,
            ProfileListWithCarousel,
            ProfileThumbnail
        }
    }
</script>

<style lang="scss" src="./home.scss"></style>
